import is from "ramda/src/is";

/**
 * Helper function that either returns a string or if an object is specified, passes is to react-intl for the localized string.
 */
const localize = (intl, str, values) => is(String, str) ? str : str && intl.formatMessage(str, values || str);

export default localize;
